import React__default from 'react';
import PT from 'prop-types';
import { F as Field } from '../internalComponents/Form/Field--hQUCvLp.js';

const FeedbackFormField = props => /*#__PURE__*/React__default.createElement(Field, props);
FeedbackFormField.propTypes = {
  children: PT.func.isRequired,
  defaultValue: PT.oneOfType([PT.string, PT.number, PT.bool]),
  id: PT.string.isRequired,
  name: PT.string.isRequired,
  validateOnMount: PT.bool
};
FeedbackFormField.defaultProps = {
  defaultValue: undefined,
  validateOnMount: true
};

export { FeedbackFormField as F };
//# sourceMappingURL=FeedbackFormField-BQYTqZo2.js.map
